export { default as letterCoffee } from './letterCoffee.png';
export { default as letterFilter } from './letterFilter.png';
export { default as letterWater } from './letterWater.png';
